import React, { Component } from 'react';
import { Container, Jumbotron } from 'reactstrap';

// modules
import styles from '../Containers.module.scss';

class NotFound extends Component {
  render() {
    return (
      <Container className={styles.NotFound}>
        <Jumbotron>
          <h1>NotFound</h1>
        </Jumbotron>
      </Container>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound/NotFound.js